import { FETCH_SETTINGS_REQUEST_ASYNC as FETCH_GROUP_SETTINGS_REQUEST_ASYNC } from 'containers/GroupSettings/Wizard/constants'

import { INPUT_CHANGE, LANDING_FROM_REQUEST_ASYNC, LANDING_FROM_UPDATE_ASYNC } from './constants'

export default function () {
  const initialState = {
    loader: false,
    data: {},
    error: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case INPUT_CHANGE: {
        const { mainKey, objKey, locale, value } = action.payload

        return {
          ...state,
          data: {
            ...state.data,
            [mainKey]: {
              ...state.data[mainKey],
              [objKey]: {
                ...state.data[mainKey][objKey],
                localized: {
                  ...state.data[mainKey][objKey].localized,
                  [locale]: value,
                },
              },
            },
          },
        }
      }
      case LANDING_FROM_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true, error: null }
      case LANDING_FROM_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          data: action.payload.data,
          loader: false,
        }
      case FETCH_GROUP_SETTINGS_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          data: action.payload.data?.landingPages,
          loader: false,
        }
      case LANDING_FROM_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case LANDING_FROM_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      case LANDING_FROM_UPDATE_ASYNC.INITIATE:
        return { ...state, loader: true, error: null }
      case LANDING_FROM_UPDATE_ASYNC.SUCCESS:
        return {
          ...state,
          data: action.payload.data,
          loader: false,
        }
      case LANDING_FROM_UPDATE_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case LANDING_FROM_UPDATE_ASYNC.CANCEL:
        return { ...state, loader: false }
      default:
        return state
    }
  }
}
